import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  
  //Reset Password On First Login
  message: string | undefined;
  submitted = false;
  password1 = '';
  password2 = '';
  resetPasswordForm =  this.formBuilder.group({
    oldPassword: ['', Validators.required ],
    password: ['', Validators.required, Validators.min(8)],
    conformPassword: ['', Validators.required, Validators.min(8)],
  });
  hide = true;
  hide2 = true;
  hide3 = true

  get f() { return this.resetPasswordForm?.controls; }

  constructor(
    private dataService : DataService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    ){

  }

  redirectHome(){
    this.router.navigate(["/home"]);
  }


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


resetPassword = async () => {
  try {
  const data = {
    password: this.f?.['password'].value ,
    conformPassword: this.f?.['conformPassword'].value,
    oldPassword: this.f?.['oldPassword'].value
  }

  var allowpassword = this.checkpassword() && this.atleast8() && this.atleastcapital() && this.atleastnumber() && this.atleastsmall() && this.atleastspecial();

    if(!allowpassword)  this.message = this.translate("Password requirements not met")
    else{
    const res =  await this.dataService.postData('user/update-password',{password : data.password, oldPassword : data.oldPassword},'PUT',false)
    if(!res.error){
      this.message = res.msg
      this.router.navigate(["/home"]);
    } else {
      this.message = this.translate(res.msg);
    }
    }
  } catch (error) {
    //console.log(error) 
  }
}




checkpassword () {

var password= this.f?.['password'].value;
var conformPassword= this.f?.['conformPassword'].value;

if(password==conformPassword) {
  return true;
} else {
  return false;
}
}

atleast8() {
var password= this.f?.['password'].value;
if(password.length > 7) {
  return true;
} else {
  return false;
}
}

atleastcapital() {
var password= this.f?.['password'].value;
return /[A-Z]/.test(password);
}

atleastsmall() {
var password= this.f?.['password'].value;
return /[a-z]/.test(password);
}

atleastnumber() {
var password= this.f?.['password'].value;
return /[0-9]/.test(password);
}

atleastspecial() {
var password= this.f?.['password'].value;

return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
}

}
